export default __webpack_public_path__ + "static/media/sound-therapy.8fe7f61c.jpg";